export type ThemeName =
  | 'aari-theme-default'
  | 'aari-theme-direct-assurance'
  | 'aari-theme-pop3p'
  | 'aari-theme-matmut'
  | 'aari-theme-france-parebrise'
  | 'aari-theme-glassdrive-ee'
  | 'aari-theme-glassdrive-es'
  | 'aari-theme-glassdrive-fi'
  | 'aari-theme-glassdrive-gr'
  | 'aari-theme-glassdrive-it'
  | 'aari-theme-glassdrive-lt'
  | 'aari-theme-glassdrive-no'
  | 'aari-theme-glassdrive-pt'
  | 'aari-theme-aaries';

export interface ThemeOptions {
  matInputAppearance?: 'fill' | 'outline';
  customer?: {
    addedSlotWidth?: number;
  };
}
